import React from 'react'

interface CreateTaskIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const CreateTaskIcon: React.FC<CreateTaskIconProps> = ({
  color = '#009C6D',
  gradient,
  width = 24,
  height = 24,
  alt = 'Create task icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 24'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M12 22.75c5.937 0 10.75-4.813 10.75-10.75S17.937 1.25 12 1.25 1.25 6.063 1.25 12 6.063 22.75 12 22.75zM24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12z'
        clipRule='evenodd'
      />
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M18.03 7.525a.625.625 0 01.07.88l-7.68 9a.625.625 0 01-.914.04l-4.32-4.263a.625.625 0 01.878-.89l3.842 3.791 7.244-8.489a.625.625 0 01.88-.07z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default CreateTaskIcon
